import styled from 'styled-components';

export const CurrencyTag = styled.span`
  background: #3e9215;
  color: #fff;
  display: inline-block;
  border-radius: 3px;
  padding: 2px 4px;
  line-height: 1;
  margin-left: 4px;
`;

export const BaseCurrencyRoot = styled.div`
  display: flex;
  align-items: center;
  font-size: 10px;
  margin-left: 4px;
  > span {
    background: #5c7080;
  }
`;
